import { MeUser } from '@sp/data/bif';
import { useEffect } from 'react';
// eslint-disable-next-line import/no-unassigned-import
import './connection';
import { STREAM_CHAT_MODEL } from './stream-chat-model';

export function useStreamChat(user: MeUser | null): void {
  useEffect(() => {
    if (user == null) {
      STREAM_CHAT_MODEL.userLoggedOut();
      return;
    }

    STREAM_CHAT_MODEL.userLoggedIn({
      image: user.avatar?.url ?? '',
      name: user.name,
      id: user.id.toString(),
    });
  }, [user]);

  useEffect(() => STREAM_CHAT_MODEL.userLoggedOut, []);
}
